// src/services/api.js
import axios from "axios";

// ✅ Usa una sola variable de entorno para la API
// En Vercel/producción debes setear: VITE_API_URL=https://elektroniks-backend.onrender.com/api
const API_BASE_URL =
  import.meta.env.VITE_API_URL ?? "http://localhost:3001/api";

// ✅ Protección: en PROD no permitas localhost (evita "Network Error" por config)
if (import.meta.env.PROD && /localhost|127\.0\.0\.1/.test(API_BASE_URL)) {
  throw new Error(
    `[API] VITE_API_URL inválida en producción (apunta a localhost): ${API_BASE_URL}`
  );
}

console.log("[API] BASE URL =>", API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  // ✅ Si usas JWT en localStorage, NO necesitas cookies
  // Si un día migras a cookies/sesión, ponlo en true y ajusta CORS en backend.
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

// 🛡️ Interceptor para agregar token (JWT)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🧯 Interceptor de errores (deja logs más claros)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const info = {
      method: error?.config?.method,
      url: error?.config?.baseURL
        ? `${error.config.baseURL}${error.config.url || ""}`
        : error?.config?.url,
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
    };

    console.error("[API ERROR]", info);
    return Promise.reject(error);
  }
);

export default api;
